export interface PageProps {
    loading: boolean
}

export interface PickerItem<T> {
    label: string
    value: T
}

export type IconSize = 'small' | 'medium' | 'large' | 'xlarge'

/**
 * TTS Configuration Constants
 */

export const TTS_CONFIG = {
    // Regex for splitting text into sentences
    // Handles: periods after digits (list markers like "1."), decimal points (0.01), newlines
    // Pattern: (?:(?<=[0-9])\.|[^.!?\n]|\.(?=\d))+[.!?\n]?
    // - (?<=[0-9])\. : Period preceded by digit (not a sentence boundary)
    // - [^.!?\n] : Any character except sentence terminators
    // - \.(?=\d) : Period followed by digit (decimal point)
    SENTENCE_SPLIT_REGEX: /(?:(?<=[0-9])\.|[^.!?\n]|\.(?=\d))+[.!?\n]?/g,

    // Timeout between end of utterance and start of next sentence (ms)
    SENTENCE_TIMEOUT_MS: 100,

    // Highlight styling
    HIGHLIGHT: {
        backgroundColor: '#ffe066',
        borderRadius: '4px',
        padding: '0 2px',
        transition: 'background 0.2s',
        boxDecorationBreak: 'clone',
        WebkitBoxDecorationBreak: 'clone',
    },

    // Scroll behavior
    SCROLL: {
        // Only scroll if highlight is in bottom 20% of viewport
        viewportThreshold: 0.8,
        behavior: 'smooth' as const,
        block: 'center' as const,
    },
} as const

/**
 * Style overrides for markdown elements
 * Allows customization of rendered markdown component appearance
 *
 * @interface StyleOverrides
 * @property {React.CSSProperties} [p] - Paragraph styles
 * @property {React.CSSProperties} [h1] - Heading 1 styles
 * @property {React.CSSProperties} [h2] - Heading 2 styles
 * @property {React.CSSProperties} [h3] - Heading 3 styles
 * @property {React.CSSProperties} [h4] - Heading 4 styles
 * @property {React.CSSProperties} [h5] - Heading 5 styles
 * @property {React.CSSProperties} [li] - List item styles
 * @property {React.CSSProperties} [ul] - Unordered list styles
 * @property {React.CSSProperties} [ol] - Ordered list styles
 * @property {React.CSSProperties} [strong] - Strong/bold styles
 * @property {React.CSSProperties} [blockquote] - Blockquote styles
 * @property {React.CSSProperties} [a] - Link styles
 */
export interface StyleOverrides {
    p?: React.CSSProperties
    h1?: React.CSSProperties
    h2?: React.CSSProperties
    h3?: React.CSSProperties
    h4?: React.CSSProperties
    h5?: React.CSSProperties
    li?: React.CSSProperties
    ul?: React.CSSProperties
    ol?: React.CSSProperties
    strong?: React.CSSProperties
    blockquote?: React.CSSProperties
    a?: React.CSSProperties
}
